export const meReducer = (me = {}, action) => {
    switch (action.type) {
        case 'set_me':
            return action.payload;
        default:
            return me;
    }
}